/**
 * Shared Multi-Section Slider System
 * Handles: Arrow states, Scroll-to-card, and Viewport-aware video autoplay
 */
class CSSlider {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.grid = wrapper.querySelector('.cs-slider-grid');
    this.prevBtn = wrapper.querySelector('.cs-prev-btn');
    this.nextBtn = wrapper.querySelector('.cs-next-btn');
    
    if (!this.grid) return;

    this.gap = parseInt(wrapper.dataset.gap) || 0;
    this.isMobileOnly = wrapper.dataset.mobileOnly === 'true';
    this.videoAutoplay = wrapper.dataset.videoAutoplay === 'true';

    this.init();
  }

  init() {
    // Arrow click handlers
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.scroll(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.scroll(1));
    }

    // Scroll listener for buttons
    this.grid.addEventListener('scroll', () => this.updateButtons());
    
    // Resize listener for mobile-only check
    window.addEventListener('resize', () => this.updateButtons());

    // Initial button state
    this.updateButtons();

    // Setup video observer if needed
    if (this.videoAutoplay) {
      this.initVideoObserver();
    }
  }

  scroll(direction) {
    const firstItem = this.grid.firstElementChild;
    if (!firstItem) return;

    const scrollAmount = firstItem.offsetWidth + this.gap;
    this.grid.scrollBy({
      left: direction * scrollAmount,
      behavior: 'smooth'
    });
  }

  updateButtons() {
    if (this.isMobileOnly && window.innerWidth > 768) {
      if (this.prevBtn) this.prevBtn.disabled = true;
      if (this.nextBtn) this.nextBtn.disabled = true;
      return;
    }

    const scrollLeft = this.grid.scrollLeft;
    const maxScroll = this.grid.scrollWidth - this.grid.offsetWidth;

    if (this.prevBtn) {
      this.prevBtn.disabled = scrollLeft <= 10;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = scrollLeft >= maxScroll - 10;
    }
  }

  initVideoObserver() {
    const options = {
      root: null,
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {
            // Silently fail if browser blocks autoplay
          });
        } else {
          video.pause();
        }
      });
    }, options);

    const videos = this.grid.querySelectorAll('.trusted-video-el');
    videos.forEach(video => observer.observe(video));
  }
}

// Global initialization
document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.cs-slider-wrapper');
  wrappers.forEach(wrapper => {
    // Basic debounce to ensure dynamically loaded content is ready
    setTimeout(() => {
       new CSSlider(wrapper);
    }, 100);
  });
});
